import { render, staticRenderFns } from "./NotResponsiveNavigation.vue?vue&type=template&id=235fc096&scoped=true&"
import script from "./NotResponsiveNavigation.vue?vue&type=script&lang=js&"
export * from "./NotResponsiveNavigation.vue?vue&type=script&lang=js&"
import style0 from "./NotResponsiveNavigation.vue?vue&type=style&index=0&id=235fc096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235fc096",
  null
  
)

export default component.exports